var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrackRedTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6573 12.3733C9.6573 12.6765 9.41151 12.9223 9.10831 12.9223C8.80511 12.9223 8.55932 12.6765 8.55932 12.3733V7.72267C7.71443 7.4837 7.09536 6.70689 7.09536 5.78549C7.09536 4.67377 7.99659 3.77254 9.10831 3.77254C10.22 3.77254 11.1213 4.67377 11.1213 5.78549C11.1213 6.70689 10.5022 7.4837 9.6573 7.72267V12.3733ZM8.19333 5.78549C8.19333 6.29082 8.60298 6.70047 9.10831 6.70047C9.61364 6.70047 10.0233 6.29082 10.0233 5.78549C10.0233 5.28016 9.61364 4.87051 9.10831 4.87051C8.60298 4.87051 8.19333 5.28016 8.19333 5.78549Z",
    fill: "url(#paint0_linear_109_490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1268 17.3142H9.08982C8.76433 17.3142 8.49259 17.3142 8.26952 17.299C8.03729 17.2831 7.81794 17.249 7.60529 17.1608C7.11235 16.9565 6.72069 16.5649 6.5164 16.0719C6.42827 15.8593 6.39409 15.6399 6.37824 15.4077C6.36301 15.1846 6.36302 14.9129 6.36302 14.5874L6.36302 8.97589C5.46765 8.20474 4.89941 7.0614 4.89941 5.78549C4.89941 3.46098 6.7838 1.57659 9.10831 1.57659C11.4328 1.57659 13.3172 3.46098 13.3172 5.78549C13.3172 7.0614 12.749 8.20474 11.8536 8.97589V14.5874C11.8536 14.9129 11.8536 15.1846 11.8384 15.4077C11.8225 15.6399 11.7884 15.8593 11.7002 16.0719C11.4959 16.5649 11.1043 16.9565 10.6113 17.1608C10.3987 17.249 10.1793 17.2831 9.94711 17.299C9.72403 17.3142 9.4523 17.3142 9.1268 17.3142ZM8.02566 16.1465C8.08216 16.1699 8.168 16.1915 8.34429 16.2036C8.52552 16.2159 8.75957 16.2162 9.10831 16.2162C9.45705 16.2162 9.6911 16.2159 9.87233 16.2036C10.0486 16.1915 10.1345 16.1699 10.191 16.1465C10.415 16.0537 10.5931 15.8756 10.6859 15.6516C10.7093 15.5951 10.7309 15.5092 10.743 15.3329C10.7553 15.1517 10.7556 14.9177 10.7556 14.5689V8.71342C10.7556 8.54078 10.8368 8.37821 10.9749 8.27451C11.7315 7.706 12.2192 6.80278 12.2192 5.78549C12.2192 4.06738 10.8264 2.67457 9.10831 2.67457C7.3902 2.67457 5.99739 4.06738 5.99739 5.78549C5.99739 6.80278 6.48509 7.706 7.24177 8.27451C7.37979 8.37821 7.46099 8.54078 7.46099 8.71342V14.5689C7.46099 14.9177 7.46129 15.1517 7.47366 15.3329C7.4857 15.5092 7.50729 15.5951 7.53071 15.6516C7.62357 15.8756 7.8016 16.0537 8.02566 16.1465Z",
    fill: "url(#paint1_linear_109_490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_490",
    x1: 20.1354,
    y1: 18.4435,
    x2: -14.3906,
    y2: 6.90012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273470"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_490",
    x1: 20.1354,
    y1: 18.4435,
    x2: -14.3906,
    y2: 6.90012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273470"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackRedTemp);
export default __webpack_public_path__ + "static/media/crack-red-temp.c79f5925ace7e07ea3278aecd6e3981e.svg";
export { ForwardRef as ReactComponent };